import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { UserPaginatedRequest } from 'types'

import { userGet, userList } from './user.service'

export const userKeyFactory = {
  base: () => ['users'],
  list: (request?: UserPaginatedRequest) => [
    ...userKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  get: (uuid: string) => [...userKeyFactory.base(), 'get', uuid],
}

export const queryUserList = (request: UserPaginatedRequest) =>
  queryOptions({
    queryKey: userKeyFactory.list(request),
    queryFn: () => userList(request),
    placeholderData: keepPreviousData,
  })

export const queryUserGet = (uuid: string) =>
  queryOptions({
    queryKey: userKeyFactory.get(uuid),
    queryFn: () => userGet(uuid),
  })
